export default "__VITE_ASSET__BlKPB6C$__"